export function resetPreSelectedFilters() {
    localStorage.removeItem('selectedFilters');
    localStorage.removeItem('filterCategoryName');
    localStorage.removeItem('sortBy');
}

// export function getImageAltText(imgId) {
//     return JSON.parse(localStorage.getItem('imageSeoAlt'))[imgId] || 'sansaar image alt seo';
// }

export function getImageAltText(imgId) {
    try{
        const imageSeoAlt = JSON.parse(localStorage.getItem('imageSeoAlt')) || {};
        return imageSeoAlt[imgId];
    }catch(e) {
        console.error('Error fetching image alt text:', e);
        return ''
    }
}